import { getClassFromDeck } from "../models/deck";
import React, { useState } from "react";
import { cardWidth, cardHeight, CardComponent } from "./card";
import "./deck.css";
import { Discard } from "./discard";
import { Quest } from "../decks/quests";
import { AudioControl } from "../audio";
import shuffle from "shuffle-array";
import { Guardian } from "../cards/forest/guardian";
const renderDeckCard = (deck, index, flipped, reverseFlip) => {
    const inverseIndex = deck.cards.length - index;
    const deckType = getClassFromDeck(deck);
    const style = {
        transform: `translate(${inverseIndex * 0.1}em, ${-inverseIndex * 0.1}em)`,
    };
    let className = "deckCard";
    if (flipped) {
        className += " flip";
    }
    if (reverseFlip) {
        className += " reverseFlip";
    }
    return (React.createElement("div", { className: className, key: index, style: style },
        React.createElement("img", { src: deckType.artUrl, width: cardWidth, height: cardHeight }),
        React.createElement("span", { className: "title" }, deckType.displayName)));
};
export const DeckComponent = (props) => {
    const { deck } = props;
    const deckType = getClassFromDeck(deck);
    const [isFlipping, setFlipping] = useState(false);
    const [isShuffling, setShuffling] = useState(false);
    const style = {
        left: `${deck.position.x}rem`,
        top: `${deck.position.y}rem`,
    };
    let topCard = null;
    const bottomDeckCards = [];
    if (deck.cards.length > 1) {
        for (let i = deck.cards.length; i > 0; i--) {
            bottomDeckCards.push(renderDeckCard(deck, i));
        }
        topCard = renderDeckCard(deck, 0, isFlipping);
    }
    else if (deck.cards.length === 1) {
        topCard = (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "empty" }, renderDeckCard(deck, 0)),
            renderDeckCard(deck, 0, isFlipping)));
    }
    else if (deck.cards.length === 0) {
        topCard = React.createElement("div", { className: "empty" }, renderDeckCard(deck, 0));
    }
    if (isFlipping) {
        topCard = (React.createElement(React.Fragment, null,
            topCard,
            React.createElement(CardComponent, { card: deck.cards[deck.cards.length - 1], flip: true, transformOverride: `translate(${deck.cards.length * 0.1}em, ${-deck.cards.length * 0.1}em) rotateY(180deg)`, transformOffset: { x: `${deck.discard.length * 0.1}em`, y: `${-deck.discard.length * 0.1}em` } })));
    }
    const onClick = () => {
        draw();
    };
    const draw = () => {
        if (deckType === Quest && deck.discard.length > 0) {
            return false;
        }
        if (!isFlipping && !isShuffling) {
            if (deck.cards.length > 0) {
                drawAnimation().then((card) => {
                    if (deck.discard[deck.discard.length - 1] instanceof Guardian) {
                        AudioControl.grove_guardian.baseAudio.pause();
                    }
                    drawEffect(card);
                });
                return true;
            }
            else {
                // can't shuffle decks
                if (deck instanceof Quest) {
                    return false;
                }
                AudioControl.shuffle.play();
                setShuffling(true);
                setTimeout(() => {
                    deck.cards = shuffle(deck.discard);
                    deck.cards.forEach((card) => (card.wasPlayed = false));
                    deck.discard = [];
                    setShuffling(false);
                }, 500);
                return false;
            }
        }
        return false;
    };
    deck.draw = draw;
    const drawAnimation = () => {
        AudioControl.draw.play();
        setFlipping(true);
        return new Promise((resolve) => setTimeout(() => {
            const card = deck.cards.pop();
            card.position = { x: deck.position.x - 132, y: deck.position.y };
            AudioControl.hit_table.play();
            setFlipping(false);
            resolve(card);
        }, 500));
    };
    const drawEffect = (card) => {
        deck.discard.push(card);
        card.performEffect();
    };
    let deckSize = deck.cards.length;
    if (isFlipping) {
        deckSize--;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Discard, { deck: deck, shuffle: isShuffling }),
        React.createElement("div", { className: "deck", style: style, onClick: onClick },
            isShuffling && renderDeckCard(deck, 0, true, true),
            bottomDeckCards,
            topCard,
            deckSize > 1 && React.createElement("span", { className: "count" }, deckSize))));
};
